/**
 * DevExtreme (esm/__internal/core/m_http_request.js)
 * Version: 24.2.6
 * Build date: Mon Mar 17 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import injector from "../../core/utils/dependency_injector";
import { getWindow } from "../../core/utils/window";
const window = getWindow();
const nativeXMLHttpRequest = {
  getXhr: () => new window.XMLHttpRequest()
};
const httpRequest = injector(nativeXMLHttpRequest);
export { httpRequest };